module.exports = __webpack_public_path__ + "static/media/1_A1_14.ab60ff1d.png";